<template>
  <div>
    <CCard v-if="show">
      <CCardHeader>
        <CIcon name="cil-pencil"/>
        <strong> Domínio e Links </strong>
        <div class="card-header-actions">
          <CLink
            class="card-header-action btn-minimize"
            @click="collapsed=!collapsed">
            <CIcon :name="`cil-chevron-${collapsed ? 'top' : 'bottom'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed">
        <CCardBody>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <CForm>
              <CRow>
                <CCol>
                  <validation-provider
                    name="domínio"
                    rules="required"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      valid-feedback
                      label="Domínio"
                      v-model="form.dominio"
                      :invalid-feedback="errors[0]"
                      placeholder="www.seudominio.com.br"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow class="ml-2">
                <validation-provider
                  v-slot="{ errors }"
                  name="ID Técnico"
                  rules="required"
                  >
                    <input 
                      class="mr-2" 
                      type="checkbox" 
                      id="idTecnico" 
                      value="false"
                      v-model="form.autorization"
                      @change="onChange('form', $event)" 
                    >
                    <label for="idTecnico">{{ technicalIdText }}</label>
                    <br>
                    <span class="text-danger" v-if="errors">{{ errors[0] }}</span>
                </validation-provider>
              </CRow>
              <CRow>
                <CCol>
                  <CInput
                    label="Link Facebook"
                    placeholder="https://facebook.com/minhaempresa"
                    v-model="form.facebook"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CInput
                    label="Link Instagram"
                    placeholder="https://instagram.com/minhaempresa"
                    v-model="form.instagram"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CInput
                    label="Link Pinterest"
                    placeholder="https://pinterest.com/minhaempresa"
                    v-model="form.pinterest"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <validation-provider
                    name="menus"
                    rules="required"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CTextarea
                      rows="2"
                      horizontal
                      label="Menus"
                      valid-feedback
                      v-model="form.menus"
                      :invalid-feedback="errors[0]"
                      placeholder="Home, Loja, Blog, Contato ..."
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow class="border-top">
                <CCol class="text-right">
                  <div class="mt-2">
                    <CButton
                      v-if="form.id"
                      class="mr-2"  
                      type="submit" 
                      color="success"
                      :disabled="invalid"
                      @click.prevent="update()">
                      Atualizar
                    </CButton>
                    <CButton
                      v-else
                      type="submit" 
                      color="primary"
                      :disabled="invalid"
                      @click.prevent="save()">
                      Enviar
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </validation-observer>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'domainForm',
    props:{
      show:{
        type: Boolean,
        required: true
      },
      technicalIdText: {
        type: String,
        required: true
      }
    },
    computed: {
      form: {
        get() {
          return this.$store.state.dominio
        }
      },
      collapsed: {
        get() { 
          return this.$store.state.forms.collapsed.dominio 
        },
        set() {
          this.$store.commit('setCollapsedTrue', 'dominio')
        }
      }
    },
    methods: {
      ...mapActions(['saveDominio', 'updateDomain']),
      save() {
        this.saveDominio(this.form);
      },
      update() {
        this.updateDomain(this.form)
      },
      onChange(context, event) {
        if (context === 'store' && event === this.technicalIdText) {
          this.form.autorization = true
        } else if (context === 'form' && event.target.checked === true) {
          this.form.autorization = this.technicalIdText
        } else {
          this.form.autorization = null
        }
      }
    }
  }
</script>
